import { getContactUsLink } from './UtilFunctions';
import { getLoggedInUserId } from './fetch-json.util';
import { Link } from 'react-router-dom';
import { Alert, CircularProgress, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

export default function MessageBanner({ statusMessages, apiInProgressCount }) {
  let statusSuccessMsg = statusMessages.success;
  let statusSuccessMoreMsg = statusMessages.successMore;
  let statusErrorMsg = statusMessages.error;
  let statusErrorMoreMsg = statusMessages.errorMore;
  let statusWarningMsg = statusMessages.warning;
  let statusWarningMoreMsg = statusMessages.warningMore;
  let statusErrorMoreMsgPresent =
    statusErrorMoreMsg && statusErrorMoreMsg.length > 0;
  let statusInfoMsg = statusMessages.info;
  let statusWaitMsg = statusMessages.wait
    ? statusMessages.wait
    : 'Please Wait...';

  function goHelpDesk(errorInfo) {
    window.open(getContactUsLink(getLoggedInUserId(), errorInfo));
  }

  const style = { marginBottom: '1em', marginTop: '1em' };
  return (
    <>
      {statusSuccessMsg && (
        <Alert style={style} severity="success" aria-atomic="true">
          <Typography variant={'body1'}>{statusSuccessMsg}</Typography>
          {statusSuccessMoreMsg && (
            <Typography variant={'caption'}>{statusSuccessMoreMsg}</Typography>
          )}
        </Alert>
      )}
      {statusErrorMsg && (
        <Alert style={style} severity="error" aria-atomic="true">
          <Typography variant={'body1'}>
            {statusErrorMoreMsgPresent && 'Sorry, there was an error - '}
            {statusErrorMsg}
          </Typography>
          {statusErrorMoreMsgPresent && (
            <Typography variant={'caption'}>
              Error information : [{statusErrorMoreMsg}]
              <br /> Click{' '}
              <Link
                onClick={() =>
                  goHelpDesk(
                    `${statusErrorMsg} - Error information: ${statusErrorMoreMsg}`
                  )
                }
              >
                report this issue
              </Link>{' '}
              to help resolve the problem.
            </Typography>
          )}
        </Alert>
      )}
      {statusWarningMsg && (
        <Alert style={style} severity="warning" aria-atomic="true">
          <Typography variant={'body1'}>{statusWarningMsg}</Typography>
          {statusWarningMoreMsg && (
            <Typography variant={'caption'}>{statusWarningMoreMsg}</Typography>
          )}
        </Alert>
      )}
      {statusInfoMsg && (
        <Alert style={style} severity="info" aria-atomic="true">
          <Typography variant={'body1'}>{statusInfoMsg}</Typography>
        </Alert>
      )}
      {apiInProgressCount.count > 0 && (
        <Grid display={'flex'} justifyItems={'left'} mt={'1rem'} mb={'1rem'}>
          <CircularProgress
            data-fuel-size="small"
            style={{ width: '1.5rem', height: '1.5rem', marginRight: '.5rem' }}
          />
          <Typography variant={'paragraph'}>{statusWaitMsg}</Typography>
        </Grid>
      )}
    </>
  );
}
